import { Component, inject } from '@angular/core';
import { SessionContextService } from '@cei-ufg/ngx-cei-sso-client';

@Component({
  selector: 'cei-admin-dashboard',
  standalone: true,
  imports: [],
  templateUrl: './dashboard.component.html',
})
export class AdminDashboardComponent {
  protected readonly userLogin = inject(SessionContextService).login;
}
